<nb-card>
  <nb-card-header>
    <span>{{ title | translate }}</span>
    @if (allowedPerimeters()?.length) {
      <div class="header-right">
        <span class="pe-2">{{ selectedPerimetersCount }}</span>
        <div>
          <button nbButton (click)="submit()" [disabled]="disableClosingDiablog">
            {{ "theme.perimeters-filters-dialog.submit" | translate }}
          </button>
        </div>
      </div>
    }
  </nb-card-header>
  @if (allowedPerimeters()?.length) {
    <nb-card-body>
      <div class="column">
        <div class="column-header row" [nbSpinner]="filtersLoading()">
          <div class="col-5">
            <h4>{{ "theme.perimeters-filters-dialog.filter_sites" | translate }}</h4>
          </div>
          @if (activeFiltersNb()) {
            <div class="col-7 text-left">
              @if (activeFiltersNb() === 1) {
                {{"theme.perimeters-filters-dialog.active-filter" | translate }}
              } @else {
                {{"theme.perimeters-filters-dialog.active-filters" | translate: { filterNb: activeFiltersNb() } }}
              }
              (<span class="action-label" (click)="clearFilters()">{{ "theme.perimeters-filters-dialog.clear" | translate }}</span>)
            </div>
          }
        </div>
        <div class="filters-list">
          <label class="filter-name">
            {{ "theme.perimeters-filters-dialog.search-site" | translate }}
          </label>
          <input
            type="text"
            class="form-control col-12 mb-3"
            placeholder="-"
            (keyup)="searchSite($event)"
            [(ngModel)]="search"
          />
          @for (filter of filters; track filter.label) {
            <div class="mb-3">
              <label class="filter-name">{{ filter.label | translate }}</label>
              @if (
                filter.filtering === filterType.FILTER_VALUE &&
                (filter.dataType === dataType.DATA_TYPE_STRING ||
                filter.dataType === dataType.DATA_TYPE_NUMBER)
              ) {
                <nb-select
                  fullWidth
                  multiple
                  placeholder="-"
                  [(ngModel)]="filter.selectedValues"
                  (ngModelChange)="updateFilters()"
                  >
                  @for (value of filter.availableValues; track value) {
                    <nb-option
                      [value]="value"
                      >{{ value }}</nb-option
                      >
                  }
                </nb-select>
              }
              @if (filter.dataType === dataType.DATA_TYPE_FK) {
                <nb-select
                  fullWidth
                  multiple
                  placeholder="-"
                  [(ngModel)]="filter.selectedValues"
                  (ngModelChange)="updateFilters()"
                >
                  @for (value of filter.availableValues; track value) {
                    <nb-option
                      [value]="value['id']"
                    >
                      {{ value['label'] }}
                    </nb-option>
                  }
                </nb-select>
              }
              @if (filter.dataType === dataType.DATA_TYPE_USER) {
                <nb-select
                  fullWidth
                  multiple
                  placeholder="-"
                  [(ngModel)]="filter.selectedValues"
                  (ngModelChange)="updateFilters()"
                >
                  @for (value of filter.availableValues; track value) {
                    <nb-option
                      [value]="value"
                    >
                      {{ value | ngxUsername }}
                    </nb-option>
                  }
                </nb-select>
              }
              @if (filter.filtering === filterType.FILTER_RANGE) {
                <nb-select
                  fullWidth
                  placeholder="-"
                  [(ngModel)]="filter.selectedValueRange"
                  (ngModelChange)="updateFilters()"
                >
                  @for (value of filter.availableValuesRange; track value) {
                    <nb-option
                      [value]="value"
                    >
                      {{ value.label }}
                    </nb-option>
                  }
                </nb-select>
              }
            </div>
          }
        </div>
      </div>
      @if (filtersLoading() || filteredPerimeters?.length) {
        <div class="column">
          <div class="column-header row">
            <div class="col-6">
              <app-select-all
                [all]="allFilteredPerimeters.length"
                [selected]="selectedPerimeters.length"
                (selectAll)="toggleAll(true)"
                (unselectAll)="toggleAll(false)"
              ></app-select-all>
            </div>
          </div>
          <div class="perimeters-list">
            <ul>
              @if (filteredPerimeters.length === 0) {
                <li>
                  {{ "theme.perimeters-filters-dialog.no_matching_site" | translate }}
                </li>
              }
              <cdk-virtual-scroll-viewport
                itemSize="52"
                class="scroll-viewport"
                >
                <div
                  *cdkVirtualFor="let perimeter of filteredPerimeters"
                  class="scroll-item"
                  >
                  <li class="perimeter-item">
                    <nb-checkbox
                      [(ngModel)]="selectedPerimetersMap[perimeter.id]"
                      (ngModelChange)="onPerimeterSelectionChange(perimeter.id, $event)"
                    >
                      {{ perimeter.name }}
                    </nb-checkbox>
                  </li>
                </div>
              </cdk-virtual-scroll-viewport>
            </ul>
          </div>
        </div>
      }
      @if (!filtersLoading() && !filteredPerimeters?.length) {
        <div class="column no-sites">
          {{ 'No results, please modify your search' | translate }}
        </div>
      }
    </nb-card-body>
  }
  @if (!allowedPerimeters()?.length && !filtersLoading()) {
    <nb-card-body class="no-sites">
      {{ "You don't have access to any site, please contact your administrator" | translate }}
    </nb-card-body>
  }
  @if (filtersLoading() && !allowedPerimeters()?.length) {
    <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
  }
</nb-card>
